/* Herroepingsfunctie (VP-7.12, B-2026-09-23-9). Stap 1 gegevens, stap 2 "Herroeping bevestigen",
   stap 3 ontvangen. Backend: retailz-server POST /api/herroeping (doc 72). */
(function () {
  var form = document.getElementById('herroepen-form');
  if (!form) return;
  var stap = function (n) {
    ['1', '2', '3'].forEach(function (s) {
      var el = form.querySelector('[data-stap="' + s + '"]');
      if (el) el.classList.toggle('hidden', s !== String(n));
    });
  };
  var waarde = function (naam) { return (form.elements[naam] && form.elements[naam].value || '').trim(); };
  var fout = function (sel, tekst) {
    var el = form.querySelector(sel);
    if (!el) return;
    el.textContent = tekst || '';
    el.classList.toggle('hidden', !tekst);
  };
  /* Onze bestelnummers zijn ORD- plus negen cijfers (ORD-000125697). Wie alleen de cijfers typt,
     of "ord 125697", krijgt dezelfde vorm; iets anders blijft zoals het is en gaat zo naar de server. */
  var bestelnummer = function () {
    var v = waarde('order').replace(/\s+/g, '').replace(/^#/, '');
    var m = /^(?:ORD-?)?(\d{1,9})$/i.exec(v);
    return m ? 'ORD-' + ('000000000' + m[1]).slice(-9) : v;
  };
  var geldig = function () {
    if (waarde('naam').length < 2) return 'Vul je naam in.';
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(waarde('email'))) return 'Vul een geldig e-mailadres in.';
    if (!/^[A-Za-z0-9-]{3,40}$/.test(bestelnummer())) return 'Vul je bestelnummer in, bijvoorbeeld ORD-000125697.';
    return '';
  };
  var rij = function (dl, label, tekst) {
    var dt = document.createElement('dt'); dt.className = 'text-slate-600'; dt.textContent = label;
    var dd = document.createElement('dd'); dd.className = 'm-0 font-semibold'; dd.textContent = tekst || '—';
    dl.appendChild(dt); dl.appendChild(dd);
  };
  form.querySelector('[data-volgende]').addEventListener('click', function () {
    var f = geldig();
    fout('[data-fout]', f);
    if (f) return;
    var dl = form.querySelector('[data-samenvatting]');
    dl.textContent = '';
    rij(dl, 'Naam', waarde('naam'));
    rij(dl, 'E-mailadres', waarde('email'));
    rij(dl, 'Bestelnummer', bestelnummer());
    rij(dl, 'Producten', waarde('toelichting') || 'De hele bestelling');
    stap(2);
  });
  form.querySelector('[data-terug]').addEventListener('click', function () { fout('[data-fout2]', ''); stap(1); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var knop = form.querySelector('[data-bevestig]');
    knop.disabled = true;
    fout('[data-fout2]', '');
    fetch(form.getAttribute('data-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        naam: waarde('naam'), email: waarde('email'), order: bestelnummer(),
        toelichting: waarde('toelichting'), website: waarde('website')
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (x) {
      if (!x.ok) {
        knop.disabled = false;
        fout('[data-fout2]', x.d.error || 'Er ging iets mis. Herroepen kan ook per e-mail (service@vijvercentrum.nl) of via WhatsApp.');
        return;
      }
      var tekst = 'Ontvangen op ' + (x.d.ontvangen || '') + (x.d.kenmerk ? ', kenmerk ' + x.d.kenmerk : '') + '.';
      if (x.d.waarschuwing) tekst += ' ' + x.d.waarschuwing;
      form.querySelector('[data-bevestiging]').textContent = tekst;
      stap(3);
    }).catch(function () {
      knop.disabled = false;
      fout('[data-fout2]', 'Verbinding mislukt. Probeer het opnieuw, of herroep per e-mail (service@vijvercentrum.nl) of via WhatsApp.');
    });
  });
})();
